import React from 'react';
import { Section } from './ui/Section';
import { Check, Printer, StickyNote, RefreshCw } from 'lucide-react';
export function Features() {
  const whatsIncluded = ['Rutinas de mañana por edad (2–4 / 5–8 / 9–13)', "Tarjetas: 'Primero–Después' y 'Cuando–Entonces'", "Tarjetas de tiempo: 'Faltan 5 minutos'", 'Checklist de salida (mochila/agua/llaves)', '12 guiones de 10 segundos imprimibles', 'Tablero de puntos simple (2 estilos)'];
  return <>
      <Section background="white" data-id="element-47">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-48">
          <div className="order-2 lg:order-1" data-id="element-49">
            <div className="bg-[#FFFDF5] p-8 rounded-3xl border-2 border-[#F5C842] relative" data-id="element-50">
              <div className="absolute -top-4 -left-4 bg-[#E8845F] text-white px-4 py-1 rounded-full font-bold text-sm" data-id="element-51">
                Qué incluye el PDF
              </div>
              <ul className="space-y-4 mt-4" data-id="element-52">
                {whatsIncluded.map((item, idx) => <li key={idx} className="flex items-center" data-id="element-53">
                    <div className="bg-green-100 rounded-full p-1 mr-3" data-id="element-54">
                      <Check className="w-4 h-4 text-green-600" data-id="element-55" />
                    </div>
                    <span className="text-gray-700 font-medium" data-id="element-56">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-57">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-58">
              Todo listo para imprimir y usar
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-59">
              No necesitas leer un libro de 200 páginas. Este kit está diseñado
              para padres ocupados que necesitan una solución hoy mismo.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-60">
              {[{
              icon: <Printer data-id="element-61" />,
              text: 'Imprimes'
            }, {
              icon: <StickyNote data-id="element-62" />,
              text: 'Pegas'
            }, {
              icon: <RefreshCw data-id="element-63" />,
              text: 'Repites'
            }].map((step, idx) => <div key={idx} className="flex flex-col items-center text-center p-4 bg-gray-50 rounded-xl" data-id="element-64">
                  <div className="text-[#4AAAA5] mb-2" data-id="element-65">{step.icon}</div>
                  <span className="font-bold text-gray-900" data-id="element-66">{step.text}</span>
                </div>)}
            </div>
          </div>
        </div>
      </Section>

      <Section background="cream" data-id="element-67">
        <div className="text-center max-w-3xl mx-auto" data-id="element-68">
          <h2 className="text-3xl font-bold text-gray-900 mb-12" data-id="element-69">
            Qué cambia cuando el mapa existe
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-70">
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-71">
              <div className="text-4xl mb-4" data-id="element-72">👀</div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-73">
                Tu hijo VE lo que viene
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-74">
                Baja la ansiedad por transición y la resistencia automática.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-75">
              <div className="text-4xl mb-4" data-id="element-76">🤐</div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-77">Dejas de repetir</h3>
              <p className="text-gray-600 text-sm" data-id="element-78">
                Ahorras energía y evitas que tu voz se convierta en ruido de
                fondo.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-79">
              <div className="text-4xl mb-4" data-id="element-80">🌅</div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-81">
                Mañanas automáticas
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-82">
                El día empieza liviano, sin esa nube negra de conflicto.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </>;
}